// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__1JIKK","text":"styles_text__3Bz03"};